import { Card } from '../../components/ui/card.js';
import { useAgencyContext } from '../AgencyDetailPage.js';

export function AgencyAgentsView() {
  const { agency } = useAgencyContext();
  return (
    <Card className="p-6">
      <div className="space-y-3">
        <h2 className="font-display text-[20px] font-medium leading-none tracking-[-0.01em]">
          Agents
        </h2>
        <p className="font-sans text-[13px] leading-relaxed text-muted-foreground">
          {agency
            ? `${agency.proptreesCount} agent proptrees in this agency.`
            : 'Loading…'}{' '}
          The full list with status, proptree state, and admin actions lives
          here.
        </p>
        <div className="font-mono text-[10px] uppercase tracking-[0.08em] text-muted-foreground/70">
          Coming soon
        </div>
      </div>
    </Card>
  );
}
